const BACKEND_DO_NOT_IMPORT = "DO_NOT_IMPORT";

export const sourceColumnKey = (name) => {
    if (!name) return "";
    const idx = String(name).lastIndexOf(".");
    const key = idx >= 0 ? String(name).slice(idx + 1) : String(name);
    return key.replace(/\s+/g, "_");
};

export const parseColumnMappings = (raw) => {
    if (!raw) return [];
    try {
        const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const isMappedTarget = (targetField) =>
    Boolean(targetField) && targetField !== BACKEND_DO_NOT_IMPORT;

export const filterHeadersToMappedColumns = (headerItems, columnMappings) => {
    if (!Array.isArray(headerItems) || headerItems.length === 0) return [];
    if (!Array.isArray(columnMappings) || columnMappings.length === 0) return headerItems;

    const mappedKeys = new Set(
        columnMappings
            .filter((mapping) => mapping.sourceColumn && isMappedTarget(mapping.targetField))
            .flatMap((mapping) => {
                const source = String(mapping.sourceColumn);
                return [source, sourceColumnKey(source)];
            }),
    );

    const filtered = headerItems.filter((header) => {
        const name = header.headerName || header.columnName || "";
        return mappedKeys.has(name) || mappedKeys.has(sourceColumnKey(name));
    });

    if (mappedKeys.size > 0 && filtered.length === 0) return headerItems;
    return filtered;
};

export const visibleOverviewMappingColumns = (columns) =>
    (columns || []).filter((column) => column.status === "mapped");
